import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';

export function fetchRules(page) {
  return useApi(http.get(`rules?pageId=${page}`));
}
